import React from 'react';

import Styles from './officers.module.scss';

const Officers = () => {
  return (
    <div>
      <h3>Officers</h3>

      <p>
        Over the years, many members have donated their time by holding officer
        positions on the Executive Committee.{' '}
      </p>

      <p>
        Our records are incomplete, so if you can provide some missing details,
        please contact the{' '}
        <a href="mailto:webmaster@4-playersofcolorado.org">webmaster</a>.
      </p>

      <div className={Styles['officers-content']}>
        <div className={Styles['officers-lists']}>
          <h4 id="c-2026">2026</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Joshua Scurran</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Greg Foskey</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Wes Stroh</td>
                <td>
                  <div>
                    Secretary <small>(July-present)</small>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Bill Brownrigg</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2025">2025</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Nathan Cordova</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Joshua Scurran</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Glenn-David Arrowood</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Jason Dean</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2024">2024</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Jacob Adkisson</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Nathan Cordova</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Michael Stuemke</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Jason Dean</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2023">2023</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Craig Freeman</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Jacob Adkisson</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Scott Salzberg</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Jason Dean</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2022">2022</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Craig Freeman</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Jacob Adkisson</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Eric Mindykowksi</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Jason Dean</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2021">2021</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Craig Freeman</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Jacob Adkisson</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Eric Mindykowksi</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Jason Dean</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2020">2020</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Tom Eskridge</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Craig Freeman</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Jacob Adkisson</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Jason Heaton</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2019">2019</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Tom Eskridge</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Craig Freeman</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Ryan Taylor</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Jason Heaton</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2018">2018</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Gary Lameris</td>
                <td>
                  President <small>(Jan-Sept)</small>
                </td>
              </tr>
              <tr>
                <td>Tom Eskridge</td>
                <td>
                  <div>
                    President <small>(Sept-Dec)</small>
                  </div>
                  <div>
                    Vice President <small>(Jan-Sept)</small>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Ryan Taylor</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Greg Foskey</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2017">2017</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Gary Lameris</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Tom Eskridge</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Ryan Taylor</td>
                <td>
                  Secretary <small>(Sept-Dec)</small>
                </td>
              </tr>
              <tr>
                <td>Todd Jones</td>
                <td>
                  Secretary <small>(Jan-Sept)</small>
                </td>
              </tr>
              <tr>
                <td>Greg Foskey</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2016">2016</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Gary Lameris</td>
                <td>President</td>
              </tr>
              <tr>
                <td>John Jaruzel</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Todd Jones</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>James Murphy (Beemer)</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2015">2015</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Gary Lameris</td>
                <td>
                  President <small>(Apr-Dec)</small>
                </td>
              </tr>
              <tr>
                <td>Chris Arnold</td>
                <td>
                  President <small>(Jan-Apr)</small>
                </td>
              </tr>
              <tr>
                <td>John Jaruzel</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Todd Jones</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Wayne Freeman</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2014">2014</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Chris Arnold</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Gary Lameris</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Todd Jones</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Wayne Freeman</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2013">2013</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Chris Arnold</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Gary Lameris</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Todd Jones</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Wayne Freeman</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2012">2012</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Chris Arnold</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Gary Lameris</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Roger Rau</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Wayne Freeman</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2011">2011</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Chris Arnold</td>
                <td>President</td>
              </tr>
              <tr>
                <td></td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Roger Rau</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Wayne Freeman</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2010">2010</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Chris Arnold</td>
                <td>President</td>
              </tr>
              <tr>
                <td></td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Roger Rau</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td></td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2009">2009</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Chris Arnold</td>
                <td>President</td>
              </tr>
              <tr>
                <td></td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Roger Rau</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td></td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2008">2008</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Chris Arnold</td>
                <td>President</td>
              </tr>
              <tr>
                <td></td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Roger Rau</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td></td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2007">2007</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Chris Arnold</td>
                <td>President</td>
              </tr>
              <tr>
                <td></td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Roger Rau</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td></td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2006">2006</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>David Faull</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Willy Clarkson</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Dan Hurley</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Wayne Freeman</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2005">2005</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>David Faull</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Willy Clarkson</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Dan Hurley</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Wayne Freeman</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2004">2004</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Chris Arnold</td>
                <td>President</td>
              </tr>
              <tr>
                <td></td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Wayne Freeman</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td></td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2003">2003</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>John Jaruzel</td>
                <td>President</td>
              </tr>
              <tr>
                <td></td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Steve Maulis</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td></td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2002">2002</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>George Blackert</td>
                <td>President</td>
              </tr>
              <tr>
                <td></td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td></td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>TJ Stone</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2001">2001</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>John Jaruzel</td>
                <td>President</td>
              </tr>
              <tr>
                <td></td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td></td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>TJ Stone</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-2000">2000</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td></td>
                <td>President</td>
              </tr>
              <tr>
                <td>John Jaruzel</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Roger Rau</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>TJ Stone</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-1999">1999</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Dan Hurley</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Roger Rau</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Kay Syddall</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Michael Palan</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-1998">1998</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Johnny K</td>
                <td>President</td>
              </tr>
              <tr>
                <td></td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td></td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>TJ Stone</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-1997">1997</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Mike Grena</td>
                <td>President</td>
              </tr>
              <tr>
                <td></td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Wesley Burdine</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>TJ Stone</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-1996">1996</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Kurtis Keele</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Rich Reynolds</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>James Murphy (Beemer)</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>TJ Stone</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-1995">1995</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Joe Kuzyk</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Roger Rau</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Tim Paynter</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>TJ Stone</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-1994">1994</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Kurtis Keele</td>
                <td>President</td>
              </tr>
              <tr>
                <td>David Faull</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Joe Kuzyk</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>TJ Stone</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-1990">1990</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Kurtis Keele</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Greg Boyd</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Jerry Engel</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Art Clark</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-1989">1989</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Jim Powell</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Norman Bywater</td>
                <td>Vice President</td>
              </tr>
              <tr>
                <td>Terry Goutierez</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>Walt Gehrke</td>
                <td>Treasurer</td>
              </tr>
            </tbody>
          </table>

          <h4 id="c-1986">1986</h4>

          <table className={Styles['officers-list']}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Jim Powell</td>
                <td>President</td>
              </tr>
              <tr>
                <td>Keith Lee</td>
                <td>Secretary/Treasurer</td>
              </tr>
            </tbody>
          </table>
        </div>
        <aside className={Styles['aside']}>
          <div className={Styles['aside-content']}>
            <ul className={Styles['aside-list']}>
              <li>
                <a href="#c-2026">2026</a>
              </li>
              <li>
                <a href="#c-2025">2025</a>
              </li>
              <li>
                <a href="#c-2024">2024</a>
              </li>
              <li>
                <a href="#c-2023">2023</a>
              </li>
              <li>
                <a href="#c-2022">2022</a>
              </li>
              <li>
                <a href="#c-2021">2021</a>
              </li>
              <li>
                <a href="#c-2020">2020</a>
              </li>
              <li>
                <a href="#c-2019">2019</a>
              </li>
              <li>
                <a href="#c-2018">2018</a>
              </li>
              <li>
                <a href="#c-2017">2017</a>
              </li>
              <li>
                <a href="#c-2016">2016</a>
              </li>
              <li>
                <a href="#c-2015">2015</a>
              </li>
              <li>
                <a href="#c-2014">2014</a>
              </li>
              <li>
                <a href="#c-2015">2015</a>
              </li>
              <li>
                <a href="#c-2014">2014</a>
              </li>
              <li>
                <a href="#c-2013">2013</a>
              </li>
              <li>
                <a href="#c-2012">2012</a>
              </li>
              <li>
                <a href="#c-2011">2011</a>
              </li>
              <li>
                <a href="#c-2010">2010</a>
              </li>
              <li>
                <a href="#c-2009">2009</a>
              </li>
              <li>
                <a href="#c-2008">2008</a>
              </li>
              <li>
                <a href="#c-2007">2007</a>
              </li>
              <li>
                <a href="#c-2006">2006</a>
              </li>
              <li>
                <a href="#c-2005">2005</a>
              </li>
              <li>
                <a href="#c-2004">2004</a>
              </li>
              <li>
                <a href="#c-2003">2003</a>
              </li>
              <li>
                <a href="#c-2002">2002</a>
              </li>
              <li>
                <a href="#c-2001">2001</a>
              </li>
              <li>
                <a href="#c-2000">2000</a>
              </li>
              <li>
                <a href="#c-1999">1999</a>
              </li>
              <li>
                <a href="#c-1998">1998</a>
              </li>
              <li>
                <a href="#c-1997">1997</a>
              </li>
              <li>
                <a href="#c-1996">1996</a>
              </li>
              <li>
                <a href="#c-1995">1995</a>
              </li>
              <li>
                <a href="#c-1994">1994</a>
              </li>
              <li>1993</li>
              <li>1992</li>
              <li>1991</li>
              <li>
                <a href="#c-1990">1990</a>
              </li>
              <li>
                <a href="#c-1989">1989</a>
              </li>
              <li>1988</li>
              <li>1987</li>
              <li>
                <a href="#c-1986">1986</a>
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default Officers;
